import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    StoreSwitcherContainer as SourceStoreSwitcherContainer
} from 'SourceComponent/StoreSwitcher/StoreSwitcher.container';
import BrowserDatabase from 'Util/BrowserDatabase/BrowserDatabase';
import history from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

import { STORE_CONFIG_KEY } from './StoreSwitcher.config';

/** @namespace Elganso/Component/StoreSwitcher/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // TODO extend mapStateToProps
});

/** @namespace Elganso/Component/StoreSwitcher/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // TODO extend mapDispatchToProps
});

/** @namespace Elganso/Component/StoreSwitcher/Container */
export class StoreSwitcherContainer extends SourceStoreSwitcherContainer {
    static propTypes = {
        ...this.propTypes,
        isMenuYB: PropTypes.bool
    };

    static defaultProps = {
        ...this.defaultProps,
        isMenuYB: false
    };

    containerProps() {
        const { isMenuYB } = this.props;

        return {
            ...super.containerProps(),
            isMenuYB
        };
    }

    containerFunctions = {
        ...this.containerFunctions,
        onYBStoreItemClick: this.onYBStoreItemClick.bind(this),
        formateaCodigoStoreView: this.formateaCodigoStoreView.bind(this)
    };

    onYBStoreItemClick(value, storeLinkUrl) {
        if (value === 'languages') {
            history.push({ pathname: appendWithStoreCode(value) });
        } else {
            BrowserDatabase.deleteItem(STORE_CONFIG_KEY);
            window.location = storeLinkUrl;
        }
    }

    formateaCodigoStoreView(storeCode) {
        const STRINGS_QUITAR_STORECODEVISIBLE = ['intl_', 'INTL_', 'PT_', 'pt_', 'FR_', 'fr_', '_cn', '_CN'];

        let formatStoreCode = storeCode;

        STRINGS_QUITAR_STORECODEVISIBLE.forEach((stringQuitar) => {
            formatStoreCode = formatStoreCode.replace(stringQuitar, '');
        });

        return formatStoreCode;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreSwitcherContainer);
